import FocusTrap from 'focus-trap-react';
import * as React from 'react';
import { handleEnterKeyPress, handleEscKeyDown } from '../../../../../Accessibility/KeyboardEvents';
import clsx from 'clsx';
import ClickOutsideStore from '../../../../../ClickOutsideStore';
import PopoverIcon from './PopoverIcon';

type State = {
  isOpen: boolean;
};

interface Props {
  title: string;
  content: React.JSX.Element;
}

class Popover extends React.Component<Props> {
  actionItemsRef: React.RefObject<HTMLDivElement | null> = React.createRef();
  state: State = {
    isOpen: false,
  };

  close = () => {
    this.setState({
      isOpen: false,
    });
  };

  toggle = () => {
    const { isOpen } = this.state;
    ClickOutsideStore.addListener({ ref: this.actionItemsRef, callback: this.close });
    this.setState({ isOpen: !isOpen });
  };

  render() {
    const { isOpen } = this.state;
    const { title, content } = this.props;

    return (
      <FocusTrap
        active={isOpen}
        focusTrapOptions={{
          escapeDeactivates: false,
          allowOutsideClick: true,
          fallbackFocus: '#popover-container',
        }}
      >
        <div
          onClick={this.toggle}
          ref={this.actionItemsRef}
          data-test-actionitems={true}
          id="popover-container"
          tabIndex={-1}
        >
          <div
            data-test-dropdown-header={title}
            tabIndex={0}
            onKeyPress={handleEnterKeyPress(this.toggle)}
            onKeyDown={handleEscKeyDown(this.close)}
            className="cursor-pointer relative"
          >
            <span className="border-b-1 border-dashed border-b-teal-600">{title}</span>
          </div>
          {isOpen && (
            <>
              <div
                className={clsx(
                  'absolute w-56 p-2 border-[1px] bg-white text-sm z-10',
                  'ml-[-7rem] mt-2 rounded-md border-solid border-gray-300 text-gray-800',
                  'shadow-[0px_6px_20px_-2px_rgba(26,26,26,0.14),0px_4px_6px_rgba(26,26,26,0.06)]',
                )}
              >
                <div className="absolute left-[104px] top-[-7px]">
                  <PopoverIcon />
                </div>
                <div className={clsx('flex-col flex min-h-[5rem] max-h-52 overflow-y-auto')}>
                  {content}
                </div>
              </div>
            </>
          )}
        </div>
      </FocusTrap>
    );
  }
}

export default Popover;
